import React from 'react'
import config from '#src/config'

interface FacebookShareProps {
  shareUrl: string
  children: (share: () => void) => React.ReactNode
}

class FacebookShare extends React.Component<FacebookShareProps> {
  constructor(props: FacebookShareProps) {
    super(props)

    this.share = this.share.bind(this)
  }

  public componentDidMount() {
    const d = document
    const s = 'script'
    const id = 'facebook-jssdk'
    let js
    const fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) return
    js = d.createElement(s)
    js.id = id
    js.src = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.1&appId=${config.get(
      'facebook.app_id'
    )}&autoLogAppEvents=1`
    // @ts-ignore
    fjs.parentNode.insertBefore(js, fjs)
  }

  public share = () => {
    // @ts-ignore
    if (FB) {
      // @ts-ignore
      FB.ui({
        method: 'share',
        display: 'popup',
        href: this.props.shareUrl
      })
    }
  }

  render() {
    const { children } = this.props

    return children(this.share)
  }
}

export default FacebookShare
